import { Map } from "immutable"

import { getList, postItem } from "./utils/entity-network-requests"

const entityName = "concept"

export const getConceptList = (token, search) =>
    getList(entityName, new Map({ title: search }), token)
    
export const conceptWizard = (token, entity, extractMode = false) => {
    const requestBody = !extractMode
        ? entity
        : {
              ...entity,
              extract: extractMode
          }
    return postItem(`${entityName}/wizard`, requestBody, token)
}
